module.exports = __webpack_public_path__ + "img/figure-1.e1a2ff2e.png";